import { createContext, FC, useMemo, useState } from 'react';

interface IDocumentUserContext {
  selectedDocumentTab: string;
  setSelectedDocumentTab: (val: string) => void;
}

export const DocumentContext = createContext<IDocumentUserContext>({
  selectedDocumentTab: '',
  setSelectedDocumentTab: () => {}
});

interface IAdminContextHandlerProps {}

export const DocumentContextHandler: FC<IAdminContextHandlerProps> = ({
  children
}): JSX.Element => {
  const [selectedDocumentTab, setSelectedDocumentTab] = useState<string>('Manage Tools');
  const providerValues = useMemo(() => {
    return { selectedDocumentTab, setSelectedDocumentTab };
  }, [selectedDocumentTab, setSelectedDocumentTab]);

  return <DocumentContext.Provider value={providerValues}>{children}</DocumentContext.Provider>;
};
